export { elementContains } from '@fluentui/dom-utilities';
